import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ArticleSearchIcon = ({ fontSize, color, title, sx }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1768_608)">
        <path
          d="M57.8499 0C60.2103 0 62.4741 0.937676 64.1432 2.60675C65.8122 4.27582 66.7499 6.53957 66.7499 8.9H26.6999C24.3395 8.9 22.0757 9.83768 20.4067 11.5068C18.7376 13.1758 17.7999 15.4396 17.7999 17.8V71.2C15.4395 71.2 13.1757 70.2623 11.5067 68.5933C9.83758 66.9242 8.8999 64.6604 8.8999 62.3V8.9C8.8999 6.53957 9.83758 4.27582 11.5067 2.60675C13.1757 0.937676 15.4395 0 17.7999 0L57.8499 0Z"
          fill="currentColor"
        />
        <path
          d="M61.41 68.9746C58.2857 70.7642 54.7565 71.6848 51.175 71.6446C46.5694 71.6391 42.1002 70.0468 38.4899 67.1252C34.8795 64.2036 32.3389 60.1233 31.2787 55.544C30.2186 50.9647 30.7008 46.1539 32.6475 41.8892C34.5942 37.6245 37.8916 34.1552 42.0067 32.0421C46.1218 29.9289 50.8141 29.2954 55.3252 30.2439C59.8362 31.1924 63.9024 33.6676 66.8664 37.2693C69.8305 40.8709 71.5191 45.3886 71.6595 50.0921C71.7999 54.7957 70.3838 59.4101 67.64 63.1896L80.1 76.5396V22.2496C80.1605 21.1024 79.9865 19.9549 79.5888 18.8772C79.191 17.7995 78.5778 16.8141 77.7866 15.9812C76.9954 15.1484 76.0427 14.4855 74.9868 14.033C73.9309 13.5805 72.7938 13.348 71.645 13.3496H31.15C30.0028 13.2891 28.8553 13.4631 27.7776 13.8608C26.6999 14.2586 25.7145 14.8718 24.8816 15.663C24.0487 16.4542 23.3859 17.4069 22.9334 18.4628C22.4809 19.5188 22.2484 20.6558 22.25 21.8046V80.0996C22.1895 81.2468 22.3635 82.3943 22.7612 83.472C23.159 84.5498 23.7722 85.5351 24.5634 86.368C25.3546 87.2009 26.3073 87.8638 27.3632 88.3162C28.4192 88.7687 29.5562 89.0012 30.705 88.9996H71.2C72.3665 89.0084 73.5221 88.7757 74.5943 88.3162C75.6664 87.8567 76.6319 87.1803 77.43 86.3296L61.41 68.9746Z"
          fill="currentColor"
        />
        <path
          d="M51.1752 64.5242C58.5482 64.5242 64.5252 58.5472 64.5252 51.1742C64.5252 43.8012 58.5482 37.8242 51.1752 37.8242C43.8022 37.8242 37.8252 43.8012 37.8252 51.1742C37.8252 58.5472 43.8022 64.5242 51.1752 64.5242Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1768_608">
          <rect width="89" height="89" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </StyledSvgIcon>
);
export default ArticleSearchIcon;

ArticleSearchIcon.propTypes = customIconsPropTypes;
